import EmailConfiguration from './EmailConfiguration';

export { EmailConfiguration };
export default EmailConfiguration;
